import { createTheme } from '@mui/material/styles';
import { type IThemeOptions } from './index';
import { CommonThemeOptions } from './commonTheme';

export const Drum2NotesOptions: IThemeOptions = {
  ...CommonThemeOptions,
  themeName: 'Drum2Notes',
  components: {
    ...CommonThemeOptions.components,
    MuiButton: {
      styleOverrides: {
        outlinedPrimary: {
          color: '#d3a178',
          '&.Mui-disabled': {
            color: '#8a6d5b',
            border: '1px solid #8a6d5b',
          },
        },
        containedPrimary: {
          backgroundColor: '#d3a178',
          '&.Mui-disabled': {
            backgroundColor: '#8a6d5b',
            color: '#212121',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        primary: {
          color: '#FFFFFF',
          backgroundColor: '#d3a178',
          background: '#d3a178',
          '&.Mui-disabled': {
            background: '#caced133',
            color: '#ffffff42',
          },
        },
      },
    },
  },
  palette: {
    ...CommonThemeOptions.palette,
    primary: {
      main: '#d3a178',
      light: '#dfc0a6',
      dark: '#8e7464',
      contrastText: '#FFFFFF',
    },
  },
};

export const Drum2NotesTheme = createTheme(Drum2NotesOptions);
